import React from 'react'
import PropTypes from 'prop-types'

FileUploadSuccess.propTypes = {
  className: PropTypes.string
}

export default function FileUploadSuccess({ className = '' } = '') {
  return (
    <span className={`svg-icon svg-md-icon ${className}`}>
<svg width="64" height="63" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="20" cy="20" r="18" stroke="#E9F8EE" stroke-width="4"/>
<circle cx="20" cy="20" r="20" transform="rotate(90 20 20)" fill="#26B753"/>
<path d="M17 28.42L10.79 22.21L13.62 19.38L17 22.77L26.88 12.88L29.71 15.71L17 28.42Z" fill="white"/>
</svg>
        </span>
  )
}
